// extracted by mini-css-extract-plugin
export default {"header":"clCDi_gMZ","innerHeader":"cUch_fR0b","h2adv":"cVI8bEGPi"};